import { render } from "./emailInput.vue?vue&type=template&id=f16fccc6&scoped=true&ts=true"
import script from "./emailInput.vue?vue&type=script&lang=ts"
export * from "./emailInput.vue?vue&type=script&lang=ts"

import "./emailInput.vue?vue&type=style&index=0&id=f16fccc6&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f16fccc6"]])

export default __exports__